import { useQuery } from "react-query";
import endPoints from "apps/layout/Header/EndPoints"
import { getMenuItems, getSearchSuggestion, getUserLastSearch } from "./Services";


export const useGetHeaderMenuItems = () => {
    return useQuery([endPoints.getMenuItems], () => getMenuItems(), {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    });
  };

  export const useGetSearchSuggestions = (searchKey:string) => {
    return useQuery([endPoints.getSearchSuggestion,searchKey], () => getSearchSuggestion(searchKey), {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    });
  };

  export const useGetLastUserSearchs= () => {
    return useQuery([endPoints.getUserLastSearch], () => getUserLastSearch(), {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    });
  };